import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  Container,
  BaseControl,
  Custom,
  CondicionColumna,
  Textbox,
} from '@app/shared';

@Injectable()
export class CondictionsColumnsTableFormsService {
  constructor() { }

  /**
   * Genera el formulario de condiciones
   *
   * @param {*} template
   * @param {*} options
   * @param {CondicionColumna} [data]
   * @returns {BaseControl<any>[]}
   * @memberof CondictionsColumnsTableFormsService
   */
  getFormCondiction(template: any, options: any, data?: CondicionColumna): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Container({
        class: 'form-row form-check form-check-inline col-12',
        order: 1,
        controls: [
          new Custom({
            key: 'cboColumn',
            label: 'Columna:',
            value: data ? data.columna : null,
            template: template,
            options: options['columns'] ? options['columns'] : [],
            size: 'col-md-4',
            placeholder: 'Seleccionar la columna a condicionar',
            validations: {
              validators: [Validators.required]
            }
          }),
          new Custom({
            key: 'cboAction',
            label: 'Acción a condicionar:',
            value: data ? data.accion : null,
            template: template,
            options: [
              {key: 'Requerir', value: 'Requerir'},
              {key: 'Ignorar', value: 'Ignorar'},
              {key: 'No eliminar registro', value: 'No eliminar registro'}
            ],
            size: 'col-md-4',
            placeholder: 'Seleccionar la accion a realizar en la condición',
            validations: {
              validators: [Validators.required]
            }
          }),
          new Custom({
            key: 'cboValue',
            label: 'Valor de condición:',
            value: data ? data.valor : null,
            template: template,
            options: [
              {key: 'Lleno', value: 'Lleno'},
              {key: 'Vacio', value: 'Vacio'}
            ],
            size: 'col-md-4',
            placeholder: 'Seleccionar el valor por el cual se realizará la condición',
            validations: {
              validators: [Validators.required]
            }
          }),
        ]
      }),
      new Textbox({
        order: 3,
        key: 'txtMessage',
        label: 'Mensaje de alerta:',
        placeholder: 'Ingrese el mensaje de alerta para cuando la condicion no se cumpla.',
        value: data ? data.mensaje : null,
        validations: {
          validators: [Validators.required]
        },
        condictions: [
          {
            campoDepende: 'cboAction',
            siEs: 'Igual',
            valor: 'No eliminar registro',
            accion: 'Ocultar'
          }
        ]
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/condictions-columns-table/shared/condictions-columns-table.form.service.ts